import React, { Fragment } from "react";
import { TicketConversation, TicketPrivateConversation, Ticket, TicketStatus, TicketGroup, TicketType} from "../../http/protocol";
import { getContainer } from "../../ioc/IOCSetup";
import { RouteComponentProps, withRouter } from "react-router";
import { LoadingViewState, RouterView } from "../RouterView";
import { TicketService } from "../../services/TicketService";
import { formatDate } from "../../util/date";
import { TicketsNotesConversation, NoteType } from "../notes/TicketsNotesConversation";
import { FormSubmitError, FormSubmitSuccess } from "../form/FormFeedback";
import { Form, FormListener } from "../form/Form";
import { FormGroup } from "../form/FormGroup";
import { SelectInput } from "../form/SelectInput";
import { Submit } from "../form/Submit";
import { ConfirmModal } from "../../util/ConfirmModal";

interface State extends LoadingViewState {
    ticket?: Ticket;
    updateType?: string;
    validationMap?: any;
    showModal?: boolean;
    idDeleteConversation:string;
}

interface Props extends RouteComponentProps {

}

export class TicketView extends RouterView<Props, State> implements FormListener<Ticket>{

    service: TicketService;
    constructor(props: Props) {
        super(props);
        this.service = getContainer().getTicketService();
        this.state = { ticket: {}, validationMap: {}, loading: true , showModal: false, idDeleteConversation:""};
    }

    loadContent(): Promise<any> | undefined {
        let id = (this.props.match.params as any).id;
        return this.service.getTicket(id).then((a: Ticket) => {
            a.conversations && a.conversations!.reverse();
            a.private_conversations && a.private_conversations!.reverse();
            this.setState({ ticket: a });
        })

    }

    setUpdateType(event: any, updateType: string): void {
        this.setState({ updateType: updateType })
    }

    onSubmit(): Promise<any> | undefined {
        let ticket = this.state.ticket;

        if (!ticket ) return;

        return this.service.updateTicket(ticket.id,{
            "type": ticket.type,
            "subtype": ticket.subtype,
            "status": ticket.status,
            "groups": ticket.groups
        }).then((tic:Ticket)=>{
            this.setState({ ticket: tic });
        })
    }

    formDidUpdate(formModel: Ticket, validationMap?: any) {
        this.setState({ ticket: formModel, validationMap: validationMap })
    }

    addConversation(comment: string) {

        let ticket_id = this.state.ticket ? this.state.ticket.id : "";
        let conversation: TicketConversation = { ticket_id: ticket_id, comment: comment };
        this.service.addTicketConversation(conversation).then((response: TicketConversation) => {
            setTimeout(() => {
                this.loadContent()
            }, 2000)
        })

    }

    deleteConversation(id: string) {
        let ticket_id = this.state.ticket ? this.state.ticket.id : "" ;
        if(ticket_id!== undefined){
            this.service.deleteTicketConversation(ticket_id,id).then((response: TicketConversation) => {
                setTimeout(() => {
                        this.loadContent()
                }, 2000)
            })
        }
        this.setState({ showModal: false })    
    }

    modalDeleteConversation(id: string) {
        this.setState({ showModal: true, idDeleteConversation:id })
    }


    addPrivateConversation(comment: string) {
        let ticket_id = this.state.ticket ? this.state.ticket.id : "";
        let conversation: TicketPrivateConversation = { ticket_id: ticket_id, comment: comment }
        this.service.addPrivateConversation(conversation).then((response: TicketPrivateConversation) => {
            setTimeout(() => {
                this.loadContent()
            }, 2000)
        })

    }

    getTitle(): string {
        return "Ticket Overview";
    }

  
    renderContent() {
        if (!this.state.ticket) {
            return <span></span>
        }
        return (

            <Fragment>
                <div className="row">
                    <div className={"col-lg-12"}>
                        <div className={"row"}>
                            <div className="col-lg-12">
                                <Form className="form form-horizontal" validationMap={this.state.validationMap} modelObject={this.state.ticket} formListener={this}>
                                    <FormSubmitError />
                                    <FormSubmitSuccess text={"Ticket " + this.state.updateType + " was updated successfully"} />
                                    <div className={"card-box"}>
                                        <div className="ibox-content">
                                            <h4>User ID : {this.state.ticket.requested_by}</h4>
                                            <table className={"table table-striped"}>
                                                <tbody>
                                                    <tr>
                                                        <td className="col-lg-4">Ticket ID:</td>
                                                        <td className="col-lg-8">{this.state.ticket.id ? this.state.ticket.id.substring(0, 13) : "N/A"}</td>
                                                    </tr>
                                                    <tr>
                                                        <td>Subject:</td>
                                                        <td>{this.state.ticket.subject}</td>
                                                    </tr>
                                                    <tr>
                                                        <td>Created:</td>
                                                        <td>{formatDate(this.state.ticket.timestamp)}</td>
                                                    </tr>
                                                    <tr>
                                                        <td>Created By:</td>
                                                        <td>{this.state.ticket.submitted_by_type +"-"+this.state.ticket.submitted_by}</td>
                                                    </tr>
                                                    <tr>
                                                        <td>Updated:</td>
                                                        <td>{formatDate(this.state.ticket.updated_timestamp)}</td>
                                                    </tr>
                                                    <tr>
                                                        <td>Last Reviewed:</td>
                                                        <td>{formatDate(this.state.ticket.requestor_review_timestamp)}</td>
                                                    </tr>
                                                    <tr>
                                                        <td>Status Updated:</td>
                                                        <td>{formatDate(this.state.ticket.status_updated_timestamp)}</td>
                                                    </tr>
                                                    <tr>
                                                        <td>Issue Type:</td>
                                                        <td>
                                                            <div className="row">
                                                                <div className="col-lg-6">
                                                                    <FormGroup className="form-group">
                                                                        <SelectInput name="type" className="form-control" model="type" optional={true} values={Object.keys(TicketType)} required={true}/>
                                                                    </FormGroup>
                                                                </div>
                                                            </div>
                                                        </td>

                                                    </tr>
                                                    <tr>
                                                        <td>Issue Subtype:</td>
                                                        <td> 
                                                            <div className="row">
                                                                <div className="col-lg-6">
                                                                    <FormGroup className="form-group">
                                                                        <SelectInput name="subtype" className="form-control" model="subtype" optional={true} values={this.service.getSubtypeByType(this.state.ticket.type!)} required={true}/>
                                                                    </FormGroup>
                                                                </div>
                                                            </div>
                                                        </td>

                                                    </tr>
                                                    <tr>
                                                        <td>Status:</td>
                                                        <td>
                                                            <div className="row">
                                                                <div className="col-lg-6">
                                                                    <FormGroup className="form-group">
                                                                        <SelectInput name="status" className="form-control" model="status" values={Object.keys(TicketStatus)} />
                                                                    </FormGroup>
                                                                </div>
                                                            </div>
                                                        </td>
                                                    </tr>
                                                    <tr>
                                                        <td>Assigned:</td>
                                                        <td>
                                                            <div className="row">
                                                                <div className="col-lg-6">
                                                                    <FormGroup className="form-group">
                                                                        <SelectInput name="groups" className="form-control" model="groups" multiple={true}  values={Object.keys(TicketGroup)} />
                                                                    </FormGroup>
                                                                </div>
                                                            </div>
                                                        </td>
                                                    </tr>
                                                    <tr>
                                                        <td>Message:</td>
                                                        <td><textarea className={"form-control chat-input"} rows={10} cols={50} maxLength={1000} value={this.state.ticket.text} disabled={true}/></td>
                                                    </tr>
                                                    <tr>
                                                        <td>Satisfaction:</td>
                                                        <td>{this.state.ticket.satisfaction_rate}</td>
                                                    </tr>
                                                    <tr>
                                                        <td>
                                                            <Submit className="btn  btn-primary" onClick={(event: any) => this.setUpdateType(event, "")}>Submit</Submit>
                                                        </td>
                                                        <td></td>
                                                    </tr>
                                                </tbody>
                                            </table>
                                        </div>
                                    </div>
                                </Form>
                            </div>
                        </div>
                    </div>
                </div>
                <div className="hr-line-dashed"></div>
                <div className={"row"}>
                    <div className={"col-sm-8"}>
                        <TicketsNotesConversation
                            notes={this.state.ticket.conversations || []}
                            ticket_id={"" + this.state.ticket.id}
                            title={"Conversation"}
                            addComment={(comment: string) => { this.addConversation(comment) }}
                            deleteComment={(id: string) => { this.modalDeleteConversation(id) }}
                            expanded={true}
                            noteType={NoteType.PUBLIC}
                            ticketLastReviewed={this.state.ticket.requestor_review_timestamp}
                        />
                    </div>
                    <div className={"col-sm-4"} >
                        <TicketsNotesConversation 
                            notes={this.state.ticket.private_conversations || []} 
                            ticket_id={"" + this.state.ticket.id} 
                            title={"Private Conversation"} 
                            addComment={(comment: string) => { this.addPrivateConversation(comment) }}
                            deleteComment={(id: string) => {}}
                            expanded={false}
                            noteType={NoteType.PRIVATE}
                        />
                    </div>
                </div>
                <div>
                    {
                        this.state.showModal===true && (
                            <ConfirmModal
                                show={this.state.showModal} 
                                heading="Delete Conversation"
                                description={ `Please click OK to delete conversation` }
                                okLabel="Delete"
                                okClassName="btn btn-danger"
                                onOk={ this.deleteConversation.bind(this,this.state.idDeleteConversation) }
                                onCancel={ () => this.setState({ showModal: false })}
                            />
                        )
                    }
                </div>
            </Fragment>
        )
    }

}

export default withRouter(TicketView);

